export interface Lineup {
  title: string;
  images: string[]; // Array of images (at least one required)
  video?: string; // Optional video URL
  description?: string;
  type?: 'image' | 'video' | 'both'; // Type of media
  site: 'A' | 'B' | 'Mid' | 'Other'; // Site classification
  credit?: string; // Optional credit/attribution for the lineup creator
  socialLinks?: {
    youtube?: string;
    twitch?: string;
    x?: string;
    instagram?: string;
    steam?: string;
  };
}

export interface MapData {
  name: string;
  displayName: string;
  image: string;
  previewImage?: string; // Optional preview image for map selection cards
  CT: Lineup[];
  T: Lineup[];
}

export const maps: Record<string, MapData> = {
  ancient: {
    name: 'ancient',
    displayName: 'Ancient',
    image: '/images/dust2.jpg',
    previewImage: '/maps/534px-CS2_de_ancient.png',
    CT: [],
    T: [
      { 
        title: 'A Site Donut Smoke', 
        images: ['/lineups/ancient/t/a-site-donut-smoke.jpg'], 
        video: '/lineups/ancient/t/a-site-smokes.mp4', 
        description: 'Smoke a site donute.', 
        site: 'A', 
        credit: 'Ryan',
        socialLinks: {}
      },
      { title: 'A Site Temple Smoke', images: ['/lineups/ancient/t/a-site-temple-smoke.jpg'], video: '/lineups/ancient/t/a-site-smokes.mp4', description: 'Smoke a site temple.', site: 'A', credit: 'Ryan' },
      { title: 'A Site CT Smoke', images: ['/lineups/ancient/t/a-site-ct-smoke.jpg'], video: '/lineups/ancient/t/a-site-smokes.mp4', description: 'Smoke a site CT.', site: 'A', credit: 'Ryan' },
      { title: 'Spawn Donut smoke', images: ['/lineups/ancient/t/donut-smoke.jpg'], video: '/lineups/ancient/t/spawn-donut-smoke.mp4', description: 'Smoke donut from T spawn.', site: 'Mid'},
      { title: 'Spawn Redroom Smoke', images: ['/lineups/ancient/t/redroom-smoke.jpg'], video: '/lineups/ancient/t/t-spawn-redroom-smoke.mp4', description: 'Smoke redroom from T spawn', site: 'Mid' },
      { title: 'B Site Long Smoke', images: ['/lineups/ancient/t/b-site-long-smoke.jpg'], video: '/lineups/ancient/t/b-site-smokes.mp4', description: 'Smoke long b site.', site: 'B' },
      { title: 'B Site Short Smoke', images: ['/lineups/ancient/t/b-site-short-smoke.jpg'], video: '/lineups/ancient/t/b-site-smokes.mp4', description: 'Smoke short b site.', site: 'B' },
    ]
  },
  dust2: {
    name: 'dust2',
    displayName: 'Dust II',
    image: '/images/dust2.jpg',
    previewImage: '/maps/534px-CS2_Dust_2_A_Site.jpg',
    CT: [],
    T: [
      { title: 'A long Smoke', images: ['/lineups/dust2/t/a-long-waterfall-corner-smoke.png'], description: 'Smoke from T spawn to block A long', site: 'A' },
      { title: 'Mid double door smoke', images: ['/lineups/dust2/t/mid-double-door-smoke.png'], description: 'Smoke from T spawn to block double soors', site: 'Mid' },
      { title: 'B window smoke', images: ['/lineups/dust2/t/b-window-smoke.png'], description: 'Smoke from T spawn to block double soors', site: 'Mid' },
    ]
  },
  mirage: {
    name: 'mirage',
    displayName: 'Mirage',
    image: '/images/mirage.jpg',
    previewImage: '/maps/534px-CS2_de_mirage.png',
    CT: [],
    T: [
      { title: 'A Stairs Smoke', images: ['/lineups/mirage/t/a-site-stairs.jpg'], description: 'Smoke from T spawn to block A site', site: 'A', credit: 'Ryan' },
      { title: 'A Jungle Smoke', images: ['/lineups/mirage/t/a-site-jungle-smoke.jpg'], description: 'Smoke from T spawn to block A site', site: 'A' },
      { title: 'A Stairs Smoke 2', images: ['/lineups/mirage/t/a-site-stairs-2.jpg'], description: 'Smoke from T spawn to block A site', site: 'A' },
      { title: 'A Ticket Smoke', images: ['/lineups/mirage/t/a-site-ticket-smoke.jpg'], description: 'Smoke from T spawn to block A site', site: 'A' },
      { title: 'Mid connector smoke', images: ['/lineups/mirage/t/mid-connector-smoke.jpg'], description: 'Smoke from T spawn to block connector', site: 'Mid' },
      { title: 'Mid window smoke', images: ['/lineups/mirage/t/mid-window-smoke.jpg'], description: 'Smoke from T spawn to block connector', site: 'Mid' },
      { title: 'B Market window smoke', images: ['/lineups/mirage/t/b-site-window-smoke.jpg'], description: 'Smoke from T spawn to block connector', site: 'B' },
      { title: 'B Market door smoke', images: ['/lineups/mirage/t/b-site-market-door-smoke.jpg'], description: 'Smoke from T spawn to block connector', site: 'B' },
      { title: 'B short smoke', images: ['/lineups/mirage/t/b-site-short-smoke.jpg'], description: 'Smoke from T spawn to block connector', site: 'B' },
    ]
  },
  inferno: {
    name: 'inferno',
    displayName: 'Inferno',
    image: '/images/inferno.jpg',
    previewImage: '/maps/534px-CS2_de_inferno.png',
    CT: [
      { title: 'Banana smoke', images: ['/lineups/inferno/ct/b-banana-spawn-smoke.png'], description: 'Tuck in front of the chair beside the wall.', site: 'B' },
      { title: 'Mid smoke', images: ['/lineups/inferno/ct/ct-mid-spawn-smoke.png'], video: '/lineups/inferno/ct/ct-spawn-mid-smoke.mp4', description: 'Tuck in behind the chair beside the wall.', site: 'Mid' },
      { title: 'Mid smoke', images: ['/lineups/inferno/ct/ct-mid-spawn-smoke-2.png'], video: '/lineups/inferno/ct/ct-mid-spawn-smoke-2.mp4', description: 'Tuck in front of the chair beside the wall.', site: 'Mid' },
    ],
    T: [
      { 
        title: 'A site front truck smoke', 
        images: [
          '/lineups/inferno/t/a-site-front-truck-smoke.jpg',
          '/lineups/inferno/t/a-site-library-smoke.jpg'
        ],
        description: 'Align up with the center of the postcard stand. Multiple angles shown.', 
        site: 'A' 
      },
      { title: 'A site library smoke', images: ['/lineups/inferno/t/a-site-library-smoke.jpg'], description: 'Align up with the center of the postcard stand.', site: 'A' },
      { title: 'B site CT smoke', images: ['/lineups/inferno/t/b-ct-double-mouse-smoke.jpg'], description: 'Back into the corner of the small wall.', site: 'B' },
      { title: 'B site CT smoke', images: ['/lineups/inferno/t/b-ct-throw-smoke.jpg'], description: 'Back into the corner of the wooden barrels.', site: 'B' },
      { title: 'B site church smoke', images: ['/lineups/inferno/t/b-church-double-mouse-smoke.jpg'], description: 'Back into the corner of the small wall.', site: 'B' },
    ]
  },
  overpass: {
    name: 'overpass',
    displayName: 'Overpass',
    image: '/images/overpass.jpg',
    previewImage: '/maps/534px-CS2_de_overpass.png',
    CT: [],
    T: []
  },
  nuke: {
    name: 'nuke',
    displayName: 'Nuke',
    image: '/images/nuke.jpg',
    previewImage: '/maps/534px-CS2_de_nuke.png',
    CT: [],
    T: []
  },
  train: {
    name: 'train',
    displayName: 'Train',
    image: '/images/train.jpg',
    previewImage: '/maps/534px-CS2_de_train.png',
    CT: [],
    T: []
  }
}; 